import workareaService from '../../services/workarea';

export default {
  state: {
    workareaSalesOrder: {},
    workareaShippingServices: undefined,
    workareaTaxRates: undefined,
    workareaCustomerDetails: { data: false },
    workareaSearchResults: [],
    workareaReturn: { },
    workareaOriginalOrder: { }
  },

  mutations: {
    SET_WORKAREA_ORDER(state, salesOrder) {
      state.workareaSalesOrder = salesOrder;
    },
    SET_WORKAREA_CUSTOMER(state, customerDetails) {
      state.workareaCustomerDetails = customerDetails;
    },
    SET_WORKAREA_SEARCH_RESULTS(state, searchResults) {
      state.workareaSearchResults = searchResults;
    },
    CLEAR_WORKAREA_SEARCH_RESULTS(state) {
      state.workareaSearchResults = [];
    },
    CLEAR_WORKAREA_ORDER(state) {
      state.workareaSalesOrder = {};
    },
    SET_WORKAREA_SHIPPING_SERVICES(state, services) {
      state.workareaShippingServices = services;
    },
    SET_WORKAREA_TAX_RATES(state, rates) {
      state.workareaTaxRates = rates;
    },
    SET_WORKAREA_RETURN(state, response) {
      state.workareaReturn = response.return;
    },
    SET_WORKAREA_ORIGINAL_ORDER(state, salesOrder) {
      state.workareaOriginalOrder = salesOrder;
    }
  },

  getters: {
    workareaSalesOrder: state => state.workareaSalesOrder,
    workareaCustomerDetails: state => state.workareaCustomerDetails,
    workareaSearchResults: state => state.workareaSearchResults,
    workareaShippingServices: state => state.workareaShippingServices,
    workareaTaxRates: state => state.workareaTaxRates,
    workareaReturn: state => state.workareaReturn,
    workareaOriginalOrder: state => state.workareaOriginalOrder,
  },

  actions: {
    updateOrder: ({ commit }, order) => {
      commit('UPDATE_ORDER', order);
    },
    getWorkareaOrder: ({ commit }, orderNumber) => {
      workareaService.getSalesOrder(orderNumber).then((response) => {
        commit('SET_WORKAREA_ORDER', response);
      });
    },
    getWorkareaReturn: ({ commit }, orderNumber) => {
      workareaService.getReturn(orderNumber).then((ret) => {
        commit('SET_WORKAREA_RETURN', ret);
        workareaService.getSalesOrder(ret.return.order_id).then((response) => {
          commit('SET_WORKAREA_ORIGINAL_ORDER', response);
        })
      })
    },
    getCustomerDetails: ({ commit }, email) => {
      workareaService.findWorkareaCustomer(email).then((response) => {
        commit('SET_WORKAREA_CUSTOMER', response);
      });
    },
    searchWorkareaForOrders: ({ commit }, payload) => {
      return new Promise( (resolve, reject) => {
        workareaService.searchOrder(payload).then( (response) => {
          commit('SET_WORKAREA_SEARCH_RESULTS', response);
          resolve(response);
        }).catch( err => { console.error(err); reject(err)} );
      });
    },
    clearWorkareaSearchResults: ({ commit }) => {
      commit('CLEAR_WORKAREA_SEARCH_RESULTS');
    },
    clearWorkareaOrder: ( { commit } ) => {
      commit('CLEAR_WORKAREA_ORDER')
    },
    getWorkareaShippingServices: ({ commit }) => {
      workareaService.getShippingServices().then((r) => {
        commit('SET_WORKAREA_SHIPPING_SERVICES', r.data)
      });
    },
    getWorkareaTaxRates: ({ commit }) => {
      workareaService.getTaxRates().then((r) => {
        commit('SET_WORKAREA_TAX_RATES', r.rates)
      });
    },
  },
};



// WEBPACK FOOTER //
// /src/store/modules/workarea.js